import styled from "styled-components"

const BaseHeading = `
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
    margin: 0;
`

export const H1 = styled.h1`${BaseHeading} font-size: 2.5rem;`

export const H2 = styled.h2`${BaseHeading} font-size: 2rem;`

export const H3 = styled.h3`${BaseHeading} font-size: 1.75rem;`

export const H4 = styled.h4`${BaseHeading} font-size: 1.5rem;`

export const H5 = styled.h5`${BaseHeading} font-size: 1.25rem;`

export const Secondary = styled.small`
  font-size: 80%;
  font-weight: 400;
  color: #636c72;
`

const DisplayBase = `
    font-family: inherit;
    font-weight: 300;
    line-height: 1.1;
    color: inherit;
    margin: 0;
`

export const Display1 = styled.h1`${DisplayBase} font-size: 6rem;`

export const Display2 = styled.h2`${DisplayBase} font-size: 5.5rem;`

export const Display3 = styled.h3`${DisplayBase} font-size: 4.5rem;`

export const Display4 = styled.h4`${DisplayBase} font-size: 3.5rem;`



// WEBPACK FOOTER //
// ./src/UI/Headings/index.js